export default __webpack_public_path__ + "static/oauth-m-d11bd695ac314208cfe8ed178dda804a.webp";